import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'meinian-package/src/baseComponent/button'
import empty from 'image/empty/empty_card_logo.png'
import Icon from 'meinian-package/src/component/icon'
import auth_choose_analysis_bg from 'image/no_auth/auth_choose_analysis_bg.jpg'
import auth_choose_assistant_bg from 'image/no_auth/auth_choose_assistant_bg.jpg'
import auth_choose_dynamic_bg from 'image/no_auth/auth_choose_dynamic_bg.jpg'
import auth_recommend_bg from 'image/no_auth/auth_recommend_bg.jpg'
import auth_intellectRecommend_bg from 'image/no_auth/auth_intellectRecommend_bg.jpg'
import auth_sample_management_bg from 'image/no_auth/auth_sample_management_bg.jpg'
import styles from './index.module.less'

export default ({ style, type }) => {
  const history = useNavigate()

  const typeEnum = {
    analysis: auth_choose_analysis_bg,
    assistant: auth_choose_assistant_bg,
    dynamic: auth_choose_dynamic_bg,
    recommend: auth_recommend_bg,
    intellectRecommend: auth_intellectRecommend_bg,
    sample: auth_sample_management_bg,
  }
  return <div className={styles['mn-permission-page']} style={style}>
    <div className="mn-permission-page-mask" />
    <img src={typeEnum[type] || empty} />
    <div className="mn-permission-page-modal">
      <div className="mn-permission-page-modal-info">
        <Icon type="mnjinggaofilled" className="mn-permission-page-modal-info-icon" />
        <div className="mn-permission-page-modal-info-text">
          您当前版本为基础版，用户权限不足，请联系您的销售经理升级专业版
        </div>
      </div>
      <div className="mn-permission-page-modal-footer">
        <Button onClick={() => history('/home/version')}>查看更多版本权益</Button>
      </div>
    </div>
  </div>
}
